import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelecter } from "../../../../hooks/storeHooks";
import { fetchTagsData } from "../../../../store/slices/exams/thunks/fetchContentData";
import { RootState } from "../../../../store/store";
import { Box, Breadcrumbs, Stack } from "@mui/material";
import {
  fetchAllMastersForClone,
  LevelTypes,
} from "../../../../store/slices/detailedMaster/detailedMasterSlice";
import globalColors from "../../../../globalColors";
import { iconText } from "../../../../Components/CustomTexts";
import ListWrapper, { cordsType } from "./ListWrapper";
import { ObjectValues } from "../../../login";
export const dFilter = {
  exam: "",
  exam_id: "",
  goal: "",
  goal_id: "",
  section: "",
  section_id: "",
  unit: "",
  unit_id: "",
  topic: "",
  topic_id: "",
  subtopic: "",
  subtopic_id: "",
  cluster: "",
  cluster_id: "",
};
function Masters({
  level,
  onClose,
  parent,onSubmit,parent_name
}: {
  level: LevelTypes;
  onClose(): void;
  parent: any;onSubmit:any;parent_name:any
}) {
  const [filters, setFilters] = useState(dFilter);
  const dispatch = useAppDispatch();
  const { masters_clone, loading } = useAppSelecter(
    (state: RootState) => state.detailedMaster
  );
  const draftCords = {
    exam: true,
    goal: true,
    section: true,
    unit: true,
    topic: true,
    subtopic: true,
    cluster: true,
    question: true,
  };
  const [cardsSelected, setCardsSelected] =
    React.useState<cordsType>(draftCords);
  const [tempSelected, setTempSelected] = useState<ObjectValues | null>(null);
  const [selectedData, setData] = useState({});
  const fields =
    // level === "exam"
    //   ? ["exam"]
    //   : level === "goal"
    //   ? ["exam", "goal"]
    //   : level === "section"
    //   ? ["exam", "goal", "section"]
    //   : level === "unit"
    //   ? ["exam", "goal", "section", "unit"]
    //   : level === "topic"
    //   ? ["exam", "goal", "section", "unit", "topic"]
    //   : level === "subtopic"
    //   ? ["exam", "goal", "section", "unit", "topic", "subtopic"]
    //   : level === "cluster"
    //   ? ["exam", "goal", "section", "unit", "topic", "subtopic", "cluster"]
    //   :
    [
      "exam",
      "goal",
      "section",
      "unit",
      "topic",
      "subtopic",
      "cluster",
      "question",
    ];

  useEffect(() => {
    if (fields.includes("exam")) {
      dispatch(fetchAllMastersForClone({ level: "exam" }));
      dispatch(fetchTagsData());
    }
  }, [dispatch]);

  useEffect(() => {
    if (fields.includes("goal")) {
      dispatch(
        fetchAllMastersForClone({ level: "goal", parent_id: filters.exam_id })
      );
    }
  }, [dispatch, filters.exam_id]);

  useEffect(() => {
    if (fields.includes("section")) {
      dispatch(
        fetchAllMastersForClone({
          level: "section",
          parent_id: filters.goal_id,
        })
      );
    }
  }, [dispatch, filters.goal_id]);

  useEffect(() => {
    if (fields.includes("unit")) {
      dispatch(
        fetchAllMastersForClone({
          level: "unit",
          parent_id: filters.section_id,
        })
      );
    }
  }, [dispatch, filters.section_id]);

  useEffect(() => {
    if (fields.includes("topic")) {
      dispatch(
        fetchAllMastersForClone({ level: "topic", parent_id: filters.unit_id })
      );
    }
  }, [dispatch, filters.unit_id]);

  useEffect(() => {
    if (fields.includes("subtopic")) {
      dispatch(
        fetchAllMastersForClone({
          level: "subtopic",
          parent_id: filters.topic_id,
        })
      );
    }
  }, [dispatch, filters.topic_id]);

  useEffect(() => {
    if (fields.includes("cluster")) {
      dispatch(
        fetchAllMastersForClone({
          level: "cluster",
          parent_id: filters.subtopic_id,
        })
      );
    }
  }, [dispatch, filters.subtopic_id]);

  // Map singular field names to plural keys in masters_clone object
  const pluralMap: Record<string, keyof typeof masters_clone> = {
    exam: "exams",
    goal: "goals",
    section: "sections",
    unit: "units",
    topic: "topics",
    subtopic: "subtopics",
    cluster: "clusters",
  };
  return (
    <Stack
      direction="column"
      spacing={"2px"}
      height="100%"
      width="100%"
      display="flex"
      sx={{ overflow: "hidden" }}
    >
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
          p: "0 10px",
          width: "100%",
          alignItems: "flex-end",
          ".MuiBreadcrumbs-separator": {
            fontSize: "0.75rem",
            color: globalColors.primary.normalText,
            margin: "0 10px",
          },
        }}
      >
        {fields.map((field, idx) => {
          const value = filters[field as keyof typeof filters];
          // const isLast = idx === fields.length - 1;
          console.log(value, "valuevalue");
          // Show only if previous fields are selected
          const show = fields
            .slice(0, idx)
            .every((f) => filters[f as keyof typeof filters]);
          if (!show) return null;

          if (!value) {
            return iconText({
              key: `all-${field}`,
              text: `All ${field.charAt(0).toUpperCase() + field.slice(1)}${
                field.endsWith("s") ? "" : "s"
              }`,
              icon: "",
              sx: {
                color: globalColors.primary.normalText,
              },
              size: "0.75rem",
              onClick: () => {},
            });
          } else {
            return iconText({
              key: `${field}-${value}`,
              text: `${
                field.charAt(0).toUpperCase() + field.slice(1)
              } (${value})`,
              icon: "",
              sx: {
                cursor: "pointer",
                color: globalColors.primary.purple,
              },
              size: "0.75rem",
              onClick: () => {
                // Reset all filters after this field
                setFilters((prev: typeof dFilter) => {
                  const updated = { ...dFilter };
                  for (let i = 0; i < idx; i++) {
                    const f = fields[i] as keyof typeof dFilter;
                    updated[f] = prev[f];
                    const idKey = `${f}_id` as keyof typeof dFilter;
                    updated[idKey] = prev[idKey];
                  }
                  return updated;
                });
              },
              classname: "linkStyle-always",
            });
          }
        })}
      </Breadcrumbs>
      <Stack
        direction="column"
        spacing={"16px"}
        alignItems="flex-start"
        sx={{
          overflowY: "auto",
          flexGrow: 8,
          borderTop: "1px solid #e5e7eb",
        }}
        className="scrollBluePrimarythin"
      >
        {[fields[0]].map((field, idx) => {
          const getNext = (idxs: number, sa: any) => {
            const nextField = fields[idxs + 1];
            const nextFieldIdKey = `${
              fields[idxs] ?? ""
            }_id` as keyof typeof filters;
            if (nextField && filters && filters[nextFieldIdKey]) {
              const pluralKey = pluralMap[nextField as keyof typeof pluralMap];
              return (
                <ListWrapper
                  fields={fields}
                  parent={parent}
                  setData={setData}parent_name={parent_name}
                  selectedData={selectedData}
                  idx={idxs + 1}
                  level={level}
                  list={masters_clone[pluralKey] ?? []}
                  setFilters={setFilters}
                  filters={filters}onSubmit={onSubmit}
                  onClose={onClose}
                  child={getNext}
                  setTempSelected={setTempSelected}
                  setCardsSelected={setCardsSelected}
                  cardsSelected={cardsSelected}
                  tempSelected={tempSelected}
                />
              );
            } else {
              return undefined;
            }
          };
          const pluralKey = pluralMap[field as keyof typeof pluralMap];
          return (
            <ListWrapper
              fields={fields}parent_name={parent_name}
              parent={parent}
              setData={setData}
              selectedData={selectedData}
              idx={idx}
              level={level}
              list={masters_clone[pluralKey] ? masters_clone[pluralKey] : []}
              setFilters={setFilters}
              filters={filters}
              onClose={onClose}onSubmit={onSubmit}
              child={getNext}
              setCardsSelected={setCardsSelected}
              cardsSelected={cardsSelected}
              setTempSelected={setTempSelected}
              tempSelected={tempSelected}
            />
          );
        })}
      </Stack>
    </Stack>
  );
}

export default Masters;
